import { createOpenAIClient } from '~/utils/openaiClient';

const TRANSCRIPTION_MODEL = 'whisper-1';
const DEFAULT_RECORDING_FILE_NAME = 'recording.webm';
const SPEECH_MODEL = 'tts-1';
const SPEECH_VOICE = 'alloy';

export async function transcribeAudioWithOpenAiProxy(audioBlob: Blob): Promise<string> {
  const client = createOpenAIClient();
  const file = new File([audioBlob], DEFAULT_RECORDING_FILE_NAME, {
    type: audioBlob.type || 'audio/webm',
  });
  const response = await client.audio.transcriptions.create({
    file,
    model: TRANSCRIPTION_MODEL,
  });

  return response.text || '';
}

/**
 * Turn an answer into spoken audio via the same server-side proxy Whisper uses, so the OpenAI key
 * never reaches the browser.
 *
 * The model and voice sent here exist only to satisfy the SDK's required parameters — the proxy
 * pins its own and ignores whatever arrives, which is what actually bounds the cost.
 */
export async function speakAnswer(text: string, signal?: AbortSignal): Promise<Blob> {
  const client = createOpenAIClient();
  const response = await client.audio.speech.create(
    {
      model: SPEECH_MODEL,
      voice: SPEECH_VOICE,
      input: text,
    },
    { signal },
  );

  return await response.blob();
}
